import { PropsWithChildren, ReactElement } from 'react';

import Aside from './Aside';
import Content from './Content';
import { default as PageLayoutBase, PageLayoutProps } from './PageLayout';

type PageLayoutAugmented = ((props: PropsWithChildren<PageLayoutProps>) => ReactElement) & {
  Content: typeof Content;
  Aside: typeof Aside;
};

export const PageLayout = Object.assign(PageLayoutBase, {
    Content,
    Aside
}) as PageLayoutAugmented;
